import { Tooltip } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CSSProperties, useRef, useState } from 'react';

const EllipsisSpan = styled('span')<{ customStyles?: CSSProperties }>(({ customStyles }) => ({
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  width: '100%',
  maxWidth: '100%',
  display: 'block',
  minWidth: 0,
  ...customStyles,
}));

export const Ellipsis = ({
  text,
  sx,
  tooltipProps: tooltipProperties = {},
  onTruncationChange,
}: {
  text: string;
  sx?: CSSProperties;
  tooltipProps?: {
    title?: string;
    placement?: 'top' | 'bottom' | 'left' | 'right';
    hideTooltip?: boolean;
  };
  onTruncationChange?: (isTruncated: boolean) => void;
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const textReference = useRef<HTMLSpanElement>(null);

  const checkTruncation = () => {
    if (textReference.current) {
      const truncated = textReference.current.scrollWidth > textReference.current.clientWidth;
      setIsTruncated(truncated);
      onTruncationChange?.(truncated);
    }
  };

  return (
    <Tooltip
      title={isTruncated && !tooltipProperties.hideTooltip ? tooltipProperties.title || text : ''}
      placement={tooltipProperties.placement}
    >
      <EllipsisSpan ref={textReference} onMouseEnter={checkTruncation} customStyles={sx} data-testid='ellipsis'>
        {text}
      </EllipsisSpan>
    </Tooltip>
  );
};
